import { Text } from "@mantine/core";
import { PageHeader } from "../../components/pages/page-header/PageHeader";
import { MyH1 } from "../../components/UI/my-h1/MyH1";
import { BlogList } from "../../components/pages/blog/BlogList";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";
import { isPhone } from "../../constants/env";
import { MyHead } from "../../components/pages/MyHead";
import { Fragment } from "react";


// @ts-ignore
export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common"])),
      // Will be passed to the page component as props
    },
  };
}

function BlogPage() {
  const { t } = useTranslation("common");

  return (
    <Fragment>
      <MyHead title={t("our-blog")} description={t("useful-info")} />
      <PageHeader>
        <div className="text-center">
          <MyH1
            size={isPhone ? "2.5rem" : "3rem"}
            className="text-center"
            color="white"
          >
            {t("our-blog")}
          </MyH1>
          <Text className="!text-white text-[22px] font-bold">
            {t("useful-info")}
          </Text>
        </div>
      </PageHeader>
      <BlogList />
    </Fragment>
  );
}

export default BlogPage;
